import { render, staticRenderFns } from "./HeaderCart.vue?vue&type=template&id=3e8d66d5&lang=pug&"
import script from "./HeaderCart.vue?vue&type=script&lang=js&"
export * from "./HeaderCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports